import { useApi } from '@backstage/frontend-plugin-api';
import { useAsync } from 'react-use';
import { tss } from 'tss-react/mui';

import { versionApiRef } from '../api';

const useStyles = tss.create(({ theme }) => ({
  version: {
    color: theme.palette.grey[600],
    flexGrow: 1,
    fontFamily: 'monospace',
    fontSize: 12,
    padding: theme.spacing(2),
    textAlign: 'center',
    whiteSpace: 'nowrap',
  },
}));

export const BuildVersion = () => {
  const { classes } = useStyles();

  const versionApi = useApi(versionApiRef);

  const { value: buildVersion } = useAsync(async () => {
    const response = await versionApi.getVersion();

    return typeof response === 'string' ? response : response.version;
  }, [versionApi]);

  return (
    <section aria-label="Version" className={classes.version}>
      {buildVersion ? `v${buildVersion}` : 'unknown version'}
    </section>
  );
};
